import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static override targets = [ "dialog" ]

  declare readonly dialogTarget: HTMLDialogElement

  show(event: Event) {
    event.preventDefault()
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  backdropClose(event: Event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }
}
